import { uxrr } from '@zyno-io/uxrr-client';
import { OpenApiError } from '@zyno-io/openapi-client-codegen';
import { configureVfOpenApiClient, UserError } from '@zyno-io/vue-foundation';

import { client } from './generated/openapi-client/client.gen';
import { Auth } from './shared/services/auth';

const apiUrl = sessionStorage.getItem('c2c:apiUrl') || import.meta.env.VITE_APP_API_URL;

client.setConfig({
    baseUrl: apiUrl
});

configureVfOpenApiClient(client, {
    headers() {
        return {
            Authorization: `Bearer ${Auth.activeJwt}`,
            'x-uxrr-sessionid': uxrr.sessionId ?? undefined
        };
    },

    onError(err) {
        if (err instanceof OpenApiError) {
            if (
                err.response?.status === 400 &&
                err.body &&
                typeof err.body === 'object' &&
                'message' in err.body &&
                typeof err.body.message === 'string' &&
                err.body.message.includes('phoneNumber(invalidPhone)')
            ) {
                return new UserError('The phone number provided is invalid.');
            }

            if (err.response?.status === 401) {
                Auth.clearSession();
                return err;
            }
        }
    }
});
